import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';

const coreValues = [
    { title: 'Precision Over Volume', body: "One well-placed VA in a solid system beats five bad hires. We'd rather tell you we're not the right fit than place someone who won't last." },
    { title: 'Partnership Over Placement', body: "We don't disappear after the hire. The monthly audits, the annual reviews, the direct access - these aren't upsells. They're the program." },
    { title: 'Continuity Over Convenience', body: "The 12-month horizon is the minimum time needed to build something real. We're not optimizing for quick wins. We're building operational infrastructure that compounds." },
];

export function CoreValues() {
    return (
        <section className="bg-white py-24 md:py-32" data-testid="core-values">
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="mb-12">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight">
                        How We Operate.
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {coreValues.map((val, i) => (
                        <motion.div
                            key={val.title}
                            {...staggeredFadeIn(i * 0.1)}
                            className="bg-[#F8F9FA] border border-gray-100 rounded-sm p-8"
                            data-testid={`core-value-${i}`}
                        >
                            <div className="w-8 h-0.5 bg-gold-400 mb-5" />
                            <h3 className="font-montserrat font-bold text-base text-navy-900 mb-3">{val.title}</h3>
                            <p className="text-[#6B7280] text-sm leading-relaxed">{val.body}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
